import React, { useState, useEffect } from 'react';
import { auditAPI } from '../../services/api';
import toast from 'react-hot-toast';
export default function AuditTrail() {
  const [logs, setLogs] = useState([]); const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ module: '', search: '' });
  useEffect(() => { auditAPI.list(filters).then(setLogs).catch(e=>toast.error(e.message)).finally(()=>setLoading(false)); }, []);
  return (
    <div>
      <div className="toolbar"><h2>Audit Trail</h2></div>
      <div className="filters-bar">
        <select className="form-control" value={filters.module} onChange={e=>setFilters({...filters,module:e.target.value})}>
          <option value="">All Modules</option>
          {['accounts','journal','customers','vendors','invoices','bills','payments','expenses','products','inventory','assets','users','settings'].map(m=><option key={m} value={m}>{m}</option>)}
        </select>
        <input className="form-control" placeholder="Search..." value={filters.search} onChange={e=>setFilters({...filters,search:e.target.value})} />
        <button className="btn btn-primary btn-sm" onClick={()=>auditAPI.list(filters).then(setLogs)}>Filter</button>
      </div>
      {loading ? <div className="spinner" style={{margin:'40px auto'}} /> : (
        <div className="card"><div className="card-body" style={{padding:0}}>
          <table><thead><tr><th>Date/Time</th><th>User</th><th>Action</th><th>Module</th><th>Entity</th><th>Details</th></tr></thead>
            <tbody>{logs.map(l=>(<tr key={l.id}>
              <td style={{whiteSpace:'nowrap'}}>{new Date(l.created_at).toLocaleString()}</td>
              <td>{l.username || 'System'}</td>
              <td><span className={`badge badge-${l.action==='DELETE'?'voided':l.action==='CREATE'?'posted':l.action==='UPDATE'?'partial':'draft'}`}>{l.action}</span></td>
              <td>{l.module}</td>
              <td>{l.entity_type} #{l.entity_id}</td>
              <td style={{maxWidth:300,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{l.new_values ? JSON.stringify(JSON.parse(l.new_values)).substring(0,100) : '-'}</td>
            </tr>))}</tbody></table>
        </div></div>
      )}
    </div>
  );
}
